const POLL_INTERVAL_MS = 60_000;
const MAXIMUM_RELOAD_DELAY_MS = 30_000;

function entryScriptsOf(shell: Document): string {
  const { origin } = window.location;

  return Array.from(
    shell.querySelectorAll('script[type="module"][src]'),
    (script) => new URL(script.getAttribute('src') ?? '', origin),
  )
    .filter((entryScript) => entryScript.origin === origin)
    .map((entryScript) => entryScript.pathname)
    .sort()
    .join(' ');
}

async function readServedEntryScripts(): Promise<string | null> {
  const response = await fetch('/index.html', { cache: 'no-store' });
  if (!response.ok) {
    return null;
  }

  const servedShell = new DOMParser().parseFromString(await response.text(), 'text/html');
  return entryScriptsOf(servedShell) || null;
}

export function startDeploymentWatchdog(): void {
  const bootedEntryScripts = entryScriptsOf(document);
  if (!bootedEntryScripts) {
    return;
  }

  let reloadScheduled = false;

  async function reloadWhenANewerBuildIsServed(): Promise<void> {
    if (reloadScheduled) {
      return;
    }

    let servedEntryScripts: string | null;
    try {
      servedEntryScripts = await readServedEntryScripts();
    } catch {
      return;
    }

    if (servedEntryScripts === null || servedEntryScripts === bootedEntryScripts) {
      return;
    }

    reloadScheduled = true;
    console.info(
      `[shell] A newer Portal is deployed (${servedEntryScripts} replaces ${bootedEntryScripts}), reloading this tab.`,
    );
    window.setTimeout(() => {
      window.location.reload();
    }, Math.random() * MAXIMUM_RELOAD_DELAY_MS);
  }

  void reloadWhenANewerBuildIsServed();
  window.setInterval(() => void reloadWhenANewerBuildIsServed(), POLL_INTERVAL_MS);
}
